import { companyActionTypes } from "../../actionTypes/company/company.actionTypes";

const initialState = {
  loading: false,
  error: null,
  company: null,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case companyActionTypes.START_GET_COMPANY:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case companyActionTypes.RESET_COMPANY:
      return {
        ...state,
        loading: false,
        company: null,
      };

    case companyActionTypes.GET_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.payload,
      };

    case companyActionTypes.GET_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default companyReducer;
